import $ from "jquery";
import React, { Component } from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { Row } from "react-foundation";

import { getWindowRooms } from "actions";
import Loading from "components/Loading";
import Select from "react-select";
import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";
import FormWrapper from "../FormWrapper";

class SelectRoom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDropdown: false
        };
    }

    render() {
        let { rooms, input } = this.props;

        if ($.isEmptyObject(rooms)) {
            return <Loading />;
        }

        if (!this.state.showDropdown) setTimeout(() => this.setState({ showDropdown: true }), 1000);

        let kickoffClasses = "kickoff";
        let dropdownClasses = "dropdown";

        if (this.state.showDropdown) {
            kickoffClasses += " fadeout";
            dropdownClasses += " fadein";
        }

        var options = rooms.map(r => ({ value: r.id, label: r.name }));
        return (
            <div>
                <Row isColumn>
                    <h3 className={kickoffClasses}>{"Okay, let's get started..."}</h3>

                    <h3 className={dropdownClasses}>
                        This window is for my
                        <Select
                            className="efficiency-select"
                            onChange={val => input.onChange(val.value)}
                            options={options}
                            value={input.value}
                            clearable={false}
                            searchable={false}
                            placeholder=""
                        />
                    </h3>
                </Row>
                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class RoomForm extends Component {
    componentDidMount() {
        this.props.getWindowRooms();
    }

    render() {
        return (
            <form className="RoomForm" onSubmit={this.props.handleSubmit(this.props.onSubmit)}>
                <FormHeader title={""} subtitle={""} />
                <SeparatingLine />

                <FormWrapper className="VerticalAlign">
                    <Field name="WindowRoomId" component={SelectRoom} rooms={this.props.rooms} />
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    return {
        rooms: state.Window.Rooms
    };
};

export default connect(mapStateToProps, { getWindowRooms })(RoomForm);



// WEBPACK FOOTER //
// ./src/containers/WindowForm/RoomForm.js